import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
// @mui
import { Box, Stack, Drawer, Typography } from "@mui/material";
// hooks
import useResponsive from "../../../hooks/useResponsive";
// config
import { NAV } from "../../../config-global";
// components
import Logo from "../../../components/logo";
import Scrollbar from "../../../components/scrollbar";
import { NavSectionVertical } from "../../../components/nav-section";
//
import NavAccount from "./NavAccount";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useLocales } from "../../../locales";
import getSidebarConfig from "./config-navigation";
import { useTheme } from "@mui/material/styles";
import NavToggleButton from "./NavToggleButton";

// ----------------------------------------------------------------------

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function NavVertical({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const { user } = useAuthContext();
  const { currentLang } = useLocales();
  const theme = useTheme();

  const navConfig = useMemo(
    () => getSidebarConfig(user.role, user.approval, currentLang.value),
    [user, currentLang]
  );

  const isDesktop = useResponsive("up", "lg");

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <NavToggleButton
        sx={{
          top: "25vh",
          left: NAV.W_DASHBOARD - 12,
        }}
      />
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Logo />
        </Box>

        {user.role !== "shadow" && <NavAccount />}
      </Stack>

      <NavSectionVertical data={navConfig} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      {/*<NavToggleButton/>*/}

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 2,
              width: NAV.W_DASHBOARD,
              bgcolor: theme.palette.background.default,
              borderRightStyle: "dashed",
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
